import {
	type HydrationOutcomeReporter,
	captureDocumentState,
} from '@jira/platform__hydration-preservation-tracker/src/preservation-tracker.tsx';
import { getDocument } from '@atlaskit/browser-apis';

export type RegionHydrationReport = Record<string, HydrationOutcomeReporter>;

/**
 * collects preservation metrics from different page layout slots
 */
export const getRegionPreservationMetrics = (
	report: RegionHydrationReport | undefined = {},
): Record<string, number> => {
	return Object.entries(report || {}).reduce<Record<string, number>>(
		(acc, [regionName, reporter]) => {
			const outcome = reporter();
			// report in 100% basis for easier reading in analytics tools
			acc[regionName] = 100 * outcome.preservationRatio;
			return acc;
		},
		{},
	);
};
/**
 * collects information separately for different page layout slots
 */
export const setupRegionReporters = (): RegionHydrationReport => {
	const regions = getDocument()?.querySelectorAll<HTMLElement>('[data-layout-slot]');
	if (!regions) {
		return {};
	}
	return Array.from(regions).reduce<RegionHydrationReport>((acc, region) => {
		const regionName = region.getAttribute('data-testid');
		if (!regionName) {
			return acc;
		}
		acc[regionName] = captureDocumentState(region);
		return acc;
	}, {});
};
